import { HttpClient, HttpHeaders } from "@angular/common/http";
import { type Observable, throwError } from "rxjs";
import { catchError, map, shareReplay } from "rxjs/operators";
import { PiensoApp } from "@platform/navigation/interfaces";

// export interface EndpointRoot {
//   endpointRoot: string;
// }

// export const ENDPOINT_ROOT = new InjectionToken<EndpointRoot>('API endpoint root');

// const ConfigServiceFactory = (http: HttpClient, endpointRoot: EndpointRoot) => new ConfigService(http, endpointRoot.endpointRoot);

// Keyed by URL and shared by all subclasses, so concurrent callers trigger a single request.
const requests = new Map<string, Observable<string[]>>();

export class ConfigService {
  protected readonly endpoint: string;

  constructor(
    protected http: HttpClient,
    protected endpointRoot: string,
  ) {
    this.endpoint = endpointRoot + "/config/";
  }

  httpOptions() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
  }

  getPiensoApps(): Observable<PiensoApp[]> {
    return this.get("pienso_apps").pipe(map(([s]) => s.replace(/[\"\[\]]/g, "").split(" "))) as Observable<PiensoApp[]>;
  }

  get(...params: string[]): Observable<string[]> {
    const url = this.endpoint + params.join("+");
    const existing = requests.get(url);
    if (existing) {
      return existing;
    }

    const request = this.http.get<string[]>(url, this.httpOptions()).pipe(
      // Drop failed requests so the next caller retries.
      catchError((error) => {
        requests.delete(url);
        return throwError(() => error);
      }),
      shareReplay(1),
    );
    requests.set(url, request);
    return request;
  }
}
